import AppUtils from "@src/utils/appUtils";

export function trackActivity() {
  return AppUtils.simulateResponse({ result: true });
}
